












































































































import Vue from 'vue'
import Overlay from './Overlay.vue'
import debounce from 'lodash.debounce'
import BorrowForm from './ModalBorrow.vue'
import { mapActions } from 'vuex'
import { ActionType } from '@/store/types'
import { BorrowParams } from 'functions/lib/types'
export default Vue.extend({
  name: 'ModalBorrow',
  components: {
    Overlay,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    bookListingId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      username: '',
      isRegistered: false,
      isLoading: false,
      isRequestSent: false,
      isSendingRequest: false,
    }
  },
  methods: {
    ...mapActions({
      isUserValid: ActionType.VERIFY_USER,
      borrowBook: ActionType.BORROW_BOOK,
    }),
    verifyUser: debounce(async function (
      this: InstanceType<typeof BorrowForm>,
    ) {
      this.isRegistered = await this.isUserValid(this.username)
      this.isLoading = false
    },
    1000),
    async requestToBorrow() {
      this.isSendingRequest = true
      const borrowParams: BorrowParams = {
        username: this.username,
        bookListingId: this.bookListingId,
        bookTitle: this.title,
      }
      this.isRequestSent = await this.borrowBook(borrowParams)
      this.isSendingRequest = false
    },
  },
})
